import { ChevronRight } from "lucide-react";
import page1 from "../assets/page.png";
import { useState } from "react";
import PublishedResearchSidebar from "./PublishedResearchSidebar";
import OtherSidebar from "./OtherSidebar";
import { useNavigate } from "react-router-dom";
import Preprint from "../assets/preprint1.png";
import ConfrencePaper from "../assets/confrencepaper.png";
import presentationIcon from "../assets/presentation1.png";
import posterIcon from "../assets/poster-icon.png";
import dataIcon from "../assets/data-icon.png";
import othersIcon from "../assets/others-icon.png";
const addNewItems = [
  {
    title: "Published research",
    desc: "Articles, Books, etc.",
    sidebar: "published",
    icon: page1,
  },
  {
    title: "Preprint",
    desc: "Draft or paper before peer review",
    type: "preprint",
    icon: Preprint,
  },
  {
    title: "Conference Paper",
    desc: "Add a conference paper",
    type: "conference",
    icon: ConfrencePaper,
  },
  {
    title: "Presentation",
    desc: "Add a presentation",
    type: "presentation",
    icon: presentationIcon,
  },
  {
    title: "Poster",
    desc: "Add a conference poster",
    type: "poster",
    icon: posterIcon,
  },
  {
    title: "Data",
    desc: "Table, image, sequence, etc.",
    type: "data",
    icon: dataIcon,
  },
  {
    title: "Other",
    desc: "Methods, proposal, code, etc.",
    sidebar: "other",
    icon: othersIcon,
  },
];

const AddNewDropdown = ({ isOpen, onClose }) => {
  const [showPublishedSidebar, setShowPublishedSidebar] = useState(false);
  const [showOtherSidebar, setShowOtherSidebar] = useState(false);
  const navigate = useNavigate();
  if (!isOpen) return null;

  const handleClick = (item) => {
    if (item.sidebar === "published") {
      setShowPublishedSidebar(true);
    } else if (item.sidebar === "other") {
      setShowOtherSidebar(true);
    } else if (item.type) {
      // navigate(`/upload-research?type=${item.type}`);
      navigate('/publish/journal')
      onClose();
    }
  };

  return (
    <>
      <div className="dropdown-overlay" onClick={onClose}>
        <div className="dropdown" onClick={(e) => e.stopPropagation()}>
          <div className="user-icon-name">
            <h3>Add Article</h3>
            <button className="close-dropdown-btn" onClick={onClose}>
              ×
            </button>
          </div>
          <div className="link-list">
            {addNewItems.map((item, index) => (
              <div
                key={index}
                className="list-item cursor-pointer"
                onClick={() => handleClick(item)}
              >
                <div className="list-icon">
                  <img src={item.icon} alt={`${item.title} icon`} />
                </div>
                <div className="list-title flex justify-between items-center w-full">
                  <div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <h3>{item.title}</h3>
                      {item.sidebar && <ChevronRight />}
                    </div>
                    <p>{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {showPublishedSidebar && (
        <PublishedResearchSidebar
          onClose={() => {
            setShowPublishedSidebar(false);
            onClose();
          }}
        />
      )}
      {showOtherSidebar && (
        <OtherSidebar
          onClose={() => {
            setShowOtherSidebar(false);
            onClose();
          }}
        />
      )}
    </>
  );
};

export default AddNewDropdown;
